import { render, staticRenderFns } from "./CourseSearchInput.vue?vue&type=template&id=3c54d502&scoped=true"
import script from "./CourseSearchInput.vue?vue&type=script&lang=ts"
export * from "./CourseSearchInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c54d502",
  null
  
)

export default component.exports